import { useState, useEffect } from "react";
import { defaulUrl, decryptData, deleteLocalStorage, formatMoney, onfocus, encryptData } from "../components/const";
import UseFetch from "../components/UseFetch";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import ModalAddFournisseur from "../Fournisseurs/ModalAddFournisseur";
import ModalAddAgent from "../Personnel/ModalAddAgent";

const Addconteneur = () => {
    const { data, isloading } = UseFetch('get-data');
    const navigate = useNavigate();

    const fournisseurs = data?.fournisseurs || [];
    const conteneurs = data?.conteneurs || [];
    const produits = data?.produits || [];
    const transitaires = data?.transitaires || [];

    const selectedProds = decryptData("selectedProducts");
    const [prods, setProds] = useState(selectedProds || []);
    const storedInfo = decryptData("storedInfo");

    // === STATE GLOBAL CONTENEUR INFO ===
    const [conteneurInfo, setConteneurInfo] = useState({
        lib_conteneur: storedInfo?.lib_conteneur || "",
        devise: storedInfo?.devise || "",
        prix_total: storedInfo?.prix_total || 0,
        valeur_du_jour: storedInfo?.valeur_du_jour || 1,
        depense: storedInfo?.depense || 0,
        montant_achat: storedInfo?.montant_achat || 0,
        transitaire: storedInfo?.transitaire || null,
        prime_transitaire: storedInfo?.prime_transitaire || 0,
        prime_travailleurs: storedInfo?.prime_travailleurs || 0,
        loyer_mag: storedInfo?.loyer_mag || 0,
        autre_dep: storedInfo?.autre_dep || 0,
        montant_total: storedInfo?.montant_total || 0,
        fournisseur: storedInfo?.fournisseur || null,
        showPanier: storedInfo?.showPanier || false,
        selectedCont: storedInfo?.selectedCont || null,
    });
    const updateConteneurInfo = (field, value) => {
        setConteneurInfo(prev => {
            const updated = { ...prev, [field]: value };
            encryptData("storedInfo", updated);
            return updated;
        });
    };
    let status = 0;
    const [totalPrix, setTotalPrix] = useState(0);
    const [qteTotal, setQteTotal] = useState(0);
    const [error, setError] = useState(null);
    const [loader, setLoader] = useState(false);
    const [search, setSearch] = useState('')
    // === CALCUL PRIX ET QTE ===
    const handleCalulePrixTotal = () => {
        const total = prods.reduce((acc, curr) => acc + (+curr.quantite * +curr.prix), 0);
        setTotalPrix(total);
        updateConteneurInfo("montant_achat", total);
    };

    const handleCaluleQteTotal = () => {
        const total = prods.reduce((acc, curr) => acc + +curr.quantite, 0);
        setQteTotal(total);
    };

    const handleQte = (e, prod) => {
        prod.quantite = +e.target.value;
        encryptData("selectedProducts", prods);
        handleCalulePrixTotal();
        handleCaluleQteTotal();
    };

    const handlePrix = (e, prod) => {
        prod.prix = e.target.value.replace(/\D/g, "");
        encryptData("selectedProducts", prods);
        handleCalulePrixTotal();
    };

    const handleSelectProduct = (e, prod) => {
        if (!prods.find(p => p.id === prod.id)) {
            setProds([...prods, { id: prod.id, quantite: 1, prix: 0, produit: prod.produit }]);
        }
        handleCalulePrixTotal();
    };

    const handleUnSelectProduct = (e, prod) => {
        e.preventDefault();
        setProds(prods.filter(p => p.id !== prod.id));
        handleCalulePrixTotal();
    };

    // === CALCUL DEPENSE TOTALE ===
    useEffect(() => {
        const depenseTotale = conteneurInfo.prime_transitaire + conteneurInfo.prime_travailleurs + conteneurInfo.loyer_mag + conteneurInfo.autre_dep;
        updateConteneurInfo("depense", depenseTotale);
    }, [conteneurInfo.prime_transitaire, conteneurInfo.prime_travailleurs, conteneurInfo.loyer_mag, conteneurInfo.autre_dep]);

    useEffect(() => {
        encryptData("selectedProducts", prods);
        handleCalulePrixTotal();
    }, [prods]);

    useEffect(() => {
        handleCaluleQteTotal();
    }, [prods]);

    // === GESTION CHARGEMENT PRODUITS CONTENEUR ===
    const handleCharger = () => {
        if (!conteneurInfo.selectedCont) {
            setError("Entrez le numero du conteneur!");
            return;
        }
        setLoader(true);
        fetch(`${defaulUrl}stocks/liste/${+conteneurInfo.selectedCont?.value}`, {
            method: "GET",
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${decryptData('ACCESS_TOKEN')}`
            }
        })
            .then(res => res.json())
            .then(data => {
                setLoader(false);
                setProds(data);
            });
        setError(null);
    };

    // === SAUVEGARDE CONTENEUR ===
    const handleSave = () => {
        try {
            if (!conteneurInfo.fournisseur) throw new Error("Veillez selectionner le fournisseur");
            if (!conteneurInfo.devise) throw new Error("Veillez selectionner la devise des prix");
            if (!conteneurInfo.lib_conteneur) throw new Error("Veillez saisir le libelé du conteneur");
            if (!conteneurInfo.transitaire) throw new Error("Veillez choisir un transitaire");
            if (prods.length === 0) throw new Error("Veillez selectionner au moins un produit!");

            prods.forEach((p, i) => {
                if (+p.quantite < 1 || +p.prix < 1) {
                    throw new Error("Vériez le prix et la quantié sur la ligne " + (i + 1));
                }
            });

            if (!conteneurInfo.valeur_du_jour) throw new Error("Veillez saisir la valeur du jour des produits en GNF!");


            const conteneurPayload = {
                ...conteneurInfo,
                montant_total: (+conteneurInfo.valeur_du_jour * conteneurInfo.prix_total) + conteneurInfo.depense
            };

            setLoader(true);
            fetch(`${defaulUrl}conteneurs/ajout`, {
                method: "POST",
                headers: {
                    Authorization: 'Bearer ' + decryptData('ACCESS_TOKEN'),
                    Accept: 'application/json',
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    produits: prods,
                    conteneur: conteneurPayload
                })
            })
                .then(response => {
                    status = response.status;
                    setLoader(false)
                    return response.json()
                })
                .then((data) => {
                    if (status === 200) {
                        Swal.fire({ title: "Succès", text: data.message, icon: "success" });
                        deleteLocalStorage();
                        navigate(`/conteneurs`);
                    } else {
                        Swal.fire({ title: "Erreur", text: data.message, icon: "error" });
                    }
                });
        } catch (err) {
            Swal.fire({
                title: "Erreur",
                text: err.message,
                icon: "error",
                toast: true,
                position: "center",
                color: 'white',
                iconColor: 'white',
                background: 'red'
            });
        }
    };

    const handleCancel = () => {
        setProds([]);
        updateConteneurInfo("lib_conteneur", "");
        updateConteneurInfo("devise", "");
        updateConteneurInfo("prix_total", 0);
        updateConteneurInfo("selectedCont", null);
        updateConteneurInfo("showPanier", false);
        deleteLocalStorage();
    };

    const filteredProducts = produits?.filter(p => p.produit.toLowerCase().includes(search.toLowerCase()))
    // === RENDER JSX ===
    return (
        <div className="add-conteneur">
            {(loader || isloading) && <div className="loader"></div>}
            <div className="container-fluid py-2 b">
                <h2 className="font-weight-light text-center text-muted py-3">CREATION DE CONTENEUR</h2>

                {/* === Fournisseur === */}
                <div className="row">
                    <div className="col-lg-6 py-1 ">
                        <h4 className="text-secondary">Fournisseur</h4>
                        <div className="input-group">
                            <Select
                                className="w-75"
                                value={conteneurInfo.fournisseur || null}
                                options={fournisseurs.map(f => ({
                                    value: f.id,
                                    label: `${f.prenoms} ${f.nom}(${f.telephone})`
                                }))}
                                onChange={opt => updateConteneurInfo("fournisseur", opt)}
                            />
                            <a className="input-group-text bg-transparent btn btn-primary text-dark" data-bs-toggle='modal' data-bs-target='#modalAddFournisseur'>
                                <i className='bx bx-plus-circle'></i>
                            </a>
                        </div>
                    </div>
                </div>


                <div className="row" >
                    <div className="col py-2">
                        <div className="card border-primary shadow radius-15">
                            <div className="card-body" >
                                <h4 className="card-title text-muted">Informations du conteneur</h4>
                                <div className="row">
                                    <div className="col-lg-6">
                                        <fieldset className="rounded">
                                            <legend>Conteneur</legend>
                                            <div className="form-group ">
                                                <span className="card-title text-primary">Libelé du Conteneur</span>
                                                <input type="text" className="form-control" name="conteneur" id="conteneur"
                                                    value={conteneurInfo.lib_conteneur}
                                                    onChange={(e) => {
                                                        updateConteneurInfo("lib_conteneur", e.target.value);

                                                    }} />
                                            </div>
                                            <div className="row my-2">
                                                <div className="form-group col-lg-6">
                                                    <span className="card-title text-primary">Devise</span>
                                                    <select name="devise" id="deise" className="form-select" value={conteneurInfo.devise} onChange={(e) =>
                                                        updateConteneurInfo("devise", e.target.value)
                                                    }>
                                                        <option value="">Choisir une devise</option>
                                                        <option value="GNF">GNF</option>
                                                        <option value="CFA">CFA</option>
                                                        <option value="$">$</option>
                                                        <option value="Euro">Euro</option>
                                                    </select>
                                                </div>
                                                <div className="form-group col-lg-6">
                                                    <span className="card-title text-primary">Valeur du jour</span>
                                                    <div className="input-group mb-3">
                                                        <input type="text" className="form-control" placeholder="Valeur du jour" defaultValue={parseFloat(conteneurInfo.valeur_du_jour)} onChange={(e) => updateConteneurInfo('valeur_du_jour', parseFloat(e.target.value) || 0)}
                                                            onBlur={(e) => formatMoney(e)}
                                                            onFocus={(e) => onfocus(e)} />
                                                        <span className="input-group-text" id="basic-addon2">GNF</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row mb-1">
                                                <div className="form-group  col-lg-6">
                                                    <span className="card-title text-primary">Prix du conteneur en devise</span>
                                                    <div className="input-group mb-3">
                                                        <input type="text" className="form-control" placeholder="Entrez le Montant facture en devise" value={conteneurInfo.prix_total} onChange={(e) => updateConteneurInfo('prix_total', parseFloat(e.target.value) || 0)}
                                                            onBlur={(e) => formatMoney(e)}
                                                            onFocus={(e) => onfocus(e)} />
                                                        <span className="input-group-text" id="basic-addon2">{conteneurInfo.devise}</span>
                                                    </div>
                                                </div>
                                                <div className="form-group col-lg-6">
                                                    <span className="card-title text-primary">Montant total en GNF</span>
                                                    <div className="input-group mb-3">
                                                        <input type="text" className="form-control" placeholder="Valeur du jour" value={((conteneurInfo.prix_total * conteneurInfo.valeur_du_jour) + conteneurInfo.depense)?.toLocaleString()} disabled />
                                                        <span className="input-group-text" id="basic-addon2">GNF</span>
                                                    </div>

                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>
                                    <div className="col-lg-6">
                                        <fieldset className="rounded">
                                            <legend>Dépenses</legend>
                                            <div className="row my-2">
                                                <div className="form-group col-lg-6">
                                                    <span className="card-title text-primary">Agent transitaire</span>


                                                    <Select
                                                        defaultInputValue={conteneurInfo.transitaire?.label}
                                                        options={
                                                            transitaires?.map((trans) => (
                                                                {
                                                                    value: `${trans.id}`, label: `${trans.prenom} ${trans.nom}(${trans.telephone})`
                                                                }
                                                            ))
                                                        }
                                                        onChange={(trans) => updateConteneurInfo(
                                                            'transitaire', trans
                                                        )}
                                                    />


                                                </div>

                                                <div className="form-group  col-lg-6">
                                                    <span className="card-title text-primary">Prime transitaire</span>
                                                    <div className="input-group mb-3">
                                                        <input type="text" className="form-control" placeholder=""
                                                            value={conteneurInfo.prime_transitaire}
                                                            onChange={(e) => updateConteneurInfo('prime_transitaire', parseFloat(e.target.value) || 0)}
                                                            onBlur={(e) => formatMoney(e)}
                                                            onFocus={(e) => onfocus(e)} />
                                                        <span className="input-group-text" id="basic-addon2">GNF</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="form-group col-lg-6">
                                                    <span className="card-title text-primary">Prime travailleurs</span>
                                                    <div className="input-group mb-3">
                                                        <input type="text" className="form-control" placeholder="Valeur du jour" value={conteneurInfo.prime_travailleurs} onChange={(e) => updateConteneurInfo('prime_travailleurs', parseFloat(e.target.value) || 0)}
                                                            onBlur={(e) => formatMoney(e)}
                                                            onFocus={(e) => onfocus(e)} />
                                                        <span className="input-group-text" id="basic-addon2">GNF</span>
                                                    </div>
                                                </div>
                                                <div className="form-group  col-lg-6">
                                                    <span className="card-title text-primary">Loyer magasin</span>
                                                    <div className="input-group mb-3">
                                                        <input type="text" className="form-control" placeholder="Entrez le Montant facture en devise" value={conteneurInfo.loyer_mag}
                                                            onChange={(e) => updateConteneurInfo('loyer_mag', parseFloat(e.target.value) || 0)}
                                                            onBlur={(e) => formatMoney(e)}
                                                            onFocus={(e) => onfocus(e)} />
                                                        <span className="input-group-text" id="basic-addon2">GNF</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="form-group  col-lg-6">
                                                    <span className="card-title text-primary">Autres</span>
                                                    <div className="input-group mb-3">
                                                        <input type="text" className="form-control" placeholder="" value={conteneurInfo.autre_dep} onChange={(e) => {
                                                            updateConteneurInfo('autre_dep', parseFloat(e.target.value) || 0)
                                                        }}
                                                            onBlur={(e) => formatMoney(e)}
                                                            onFocus={(e) => onfocus(e)} />
                                                        <span className="input-group-text" id="basic-addon2">GNF</span>
                                                    </div>
                                                </div>
                                                <div className="form-group col-lg-6">
                                                    <span className="card-title text-primary">Dépense totale</span>
                                                    <div className="input-group mb-3">
                                                        <input type="text" className="form-control" placeholder="Entrez la depense" value={conteneurInfo.depense.toLocaleString()}
                                                            disabled />
                                                        <span className="input-group-text" id="basic-addon2">GNF</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {!conteneurInfo?.showPanier && (
                    <div className="row">
                        {prods?.length > 0 && (
                            <button
                                className="btn btn-primary m-1 btn-card shadow"
                                onClick={() => updateConteneurInfo("showPanier", true)}
                            >
                                <i className="bx bx-cart-alt fs-1"></i>
                                <span className="text-warning p-1 m-auto">{prods?.length}</span>
                            </button>
                        )}

                        <div className="row justify-content-between align-items-center bg-white py-2">
                            <div className="col-lg-6 ">

                                <div className="input-group">
                                    <Select
                                        placeholder="Charger a partir d'un conteneur"
                                        value={
                                            conteneurInfo?.selectedCont
                                                ? {
                                                    label: conteneurInfo.selectedCont.label,
                                                    value: conteneurInfo.selectedCont.id,
                                                }
                                                : null
                                        }
                                        options={conteneurs.map((cont) => ({
                                            value: cont.id,
                                            label: cont.lib_conteneur,
                                        }))}
                                        onChange={(opt) =>
                                            updateConteneurInfo("selectedCont", opt)
                                        }
                                        className="w-75"
                                    />
                                    <span
                                        className="bg-secondary-subtle px-2 rounded-end"
                                        id="basic-addon2"
                                        onClick={handleCharger}
                                    >
                                        <i className="bx bx-refresh fs-4 text-primary"></i>
                                    </span>
                                </div>
                                {error && <span className="text-danger">{error}</span>}
                            </div>

                            <input type="search" className="form-control  m-1" placeholder="chercher un produit" onChange={(e) => setSearch(e.target.value)} />

                        </div>

                        {produits.length > 0 ? (
                            <div className="row row-cols-1 row-cols-md-5 row-col-lg-6 g-2 plage">
                                {filteredProducts.map((prod) => {
                                    const isSelected = selectedProds?.some(
                                        (p) => p.id === prod.id
                                    );
                                    return (
                                        <div className="col" key={prod.id}>
                                            <div className="card rounded pointer h-100 card-magasin p-2 m-1">
                                                <span className="text-center ">
                                                    {prod.produit}
                                                </span>
                                                <div className="text-center mt-auto">
                                                    {isSelected && (
                                                        <span>
                                                            <i className="bx bx-checkbox-checked fs-4 text-success"></i>
                                                        </span>
                                                    )}
                                                    {!isSelected && (
                                                        <button
                                                            className="btn btn-primary"
                                                            onClick={(e) =>
                                                                handleSelectProduct(e, prod)
                                                            }
                                                        >
                                                            Choisir
                                                        </button>
                                                    )}
                                                    {isSelected && (
                                                        <button
                                                            className="btn btn-danger"
                                                            onClick={(e) =>
                                                                handleUnSelectProduct(e, prod)
                                                            }
                                                        >
                                                            Retirer
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            <div className="row p-3 m-2 bg-danger-subtle">
                                <h5 className="text-center">
                                    Aucun produit n'a été enregistré
                                </h5>
                            </div>
                        )}



                    </div>
                )}


                {conteneurInfo?.showPanier &&
                    <div className="row mx-1">


                        <h4 className="card-title">Saisie des Quantiés & Prix</h4>

                        <div className="table-responsive p-2 mt-2">
                            {prods?.length ?
                                <table className="table table-hover table-striped table-secondary  table-bordered">
                                    <thead className="table-dark">
                                        <tr>
                                            <td hidden>ID</td>
                                            <td >N°</td>
                                            <td>Designation Produit</td>
                                            <td>Qte</td>
                                            <td >PAU</td>
                                            <td className="text-end">Action</td>
                                        </tr>
                                    </thead>
                                    <tbody id="selectedProducts">
                                        {
                                            prods.map((pro, i) => (
                                                <tr key={i}>
                                                    <td hidden className="id"> {pro.id}</td>
                                                    <td > {i + 1}</td>
                                                    <td className="prod"> {pro.produit}</td>
                                                    <td className=" text-end qte">
                                                        <input type="number" min={1} className="form-control qte" defaultValue={+pro.quantite} onChange={(e) => handleQte(e, pro)} />

                                                    </td>
                                                    <td >

                                                        <div className="input-group mb-3">
                                                            <input type="text" className="form-control prix" placeholder="Entrez le prix unitaire" defaultValue={parseFloat(pro.prix).toLocaleString()} onChange={(e) => handlePrix(e, pro)} onBlur={(e) => formatMoney(e)}
                                                                onFocus={(e) => onfocus(e)} />

                                                        </div>

                                                    </td>
                                                    <td className="text-end">

                                                        <button onClick={(e) => handleUnSelectProduct(e, pro)} className="btn btn-danger m-1" >Retirer</button>
                                                    </td>
                                                </tr>

                                            ))
                                        }
                                        <tr className="border-0">
                                            <td colSpan={2} className="text-center fs-4 fw-bold border"> Totaux</td>
                                            <td className="border fw-bold">{qteTotal?.toLocaleString()}</td>
                                            <td className="border fw-bold">{`${totalPrix?.toLocaleString()} GNF`}</td>
                                        </tr>
                                    </tbody>
                                </table> :
                                <div className="bg-danger-subtle text-danger w-100 text-center p-2 fs-3 ">
                                    Vous n'avez pas choisi un produit!
                                </div>
                            }



                            <div className="modal-footer mb-2">
                                <button className="btn btn-primary me-5" onClick={() => updateConteneurInfo('showPanier', false)}>
                                    <i className="bx bx-chevron-left"></i>Retour</button>
                                <button className="btn btn-danger m-1" onClick={handleCancel}>Annuler</button>
                                <button className="btn btn-success m-1" onClick={() => handleSave()} disabled={loader}>Enregistrer</button>
                            </div>
                        </div>
                    </div>
                }


            </div>

            <ModalAddAgent url='transitaires' />
            <ModalAddFournisseur />
        </div>
    );
};

export default Addconteneur;
